import type { MappedFareTypeRulesInput, FareTypeRulesInput } from "./types"

export default function mapperFareTypeRules(rules: FareTypeRulesInput): MappedFareTypeRulesInput {
  return {
    rules: {
      changeDiscountAbs: Number(rules.rules.change_discount_abs),
      changeDiscountPct: rules.rules.change_discount_pct,
      currency: rules.rules.currency?.toLowerCase(),
      refundAbs: Number(rules.rules.refund_abs),
      refundPct: rules.rules.refund_pct,
      refundPriceComps: rules.rules.refund_price_comps,
      servicePackage: rules.rules.service_package,
      rulesetId: rules.ruleset_id,
      alias: rules.rules.alias,
    },
    ticket: rules.ticket,
  }
}
